<div class="radio" [class.radio--disabled]="disabled()">
  <input
    type="radio"
    [id]="id()"
    [name]="name()"
    [value]="value()"
    [checked]="isChecked()"
    [disabled]="disabled()"
    class="radio__native"
    (change)="onChange()"
  />
  <label [for]="id()" class="radio__visual-label">
    <span
      class="radio__circle"
      [class.radio__circle--checked]="isChecked()"
      aria-hidden="true"
    >
      @if (isChecked()) {
        <span class="radio__dot"></span>
      }
    </span>
    @if (label()) {
      <span class="radio__text">{{ label() }}</span>
    }
  </label>
</div>
